import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "DIAL THE TENSION",
    desc: "Select your resistance level. Lock the core. The sphere is ready in seconds — no tools, no calibration.",
    img: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?auto=format&fit=crop&w=1200&q=80",
  },
  {
    n: "02",
    title: "CLAMP & SQUEEZE",
    desc: "Wrap fingers across the five knobs. Drive force from the wrist through the palm. Hold for 5 seconds. Release.",
    img: "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?auto=format&fit=crop&w=1200&q=80",
  },
  {
    n: "03",
    title: "PROGRESS DAILY",
    desc: "Log your reps. Crank the dial as your grip gets stronger. The same sphere takes you from 40 to 99 pounds.",
    img: "https://images.unsplash.com/photo-1532029837206-abbe2b7620e3?auto=format&fit=crop&w=1200&q=80",
  },
];

const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-section" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="text-xs uppercase tracking-[0.3em] text-[#007AFF] mb-4 font-body">// 02 Protocol</div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[0.95] max-w-3xl">
            THREE STEPS.<br/>THIRTY-DAY TRANSFORMATION.
          </h2>
        </motion.div>

        <div className="grid gap-6 md:gap-0 md:grid-cols-3 border-t border-l border-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="relative border-r border-b border-white/10 group"
              data-testid={`step-${i}`}
            >
              <div className="aspect-[4/3] overflow-hidden relative">
                <img
                  src={s.img}
                  alt={s.title}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 scale-105 group-hover:scale-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-[#0a0a0a]/40 to-transparent" />
                <span className="absolute top-6 left-6 font-heading text-7xl text-[#007AFF]/80">{s.n}</span>
              </div>
              <div className="p-8 md:p-10">
                <h3 className="font-heading text-2xl mb-3 tracking-wide">{s.title}</h3>
                <p className="text-sm text-white/55 leading-relaxed">{s.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
